export default "__VITE_ASSET__C$m0t2Fu__"